<!-- Admin bar component for consistent admin UI -->
<app-admin-bar></app-admin-bar>

<div class="admin-settings-container">
  <div class="admin-settings-header">
    <h1>Portal: Settings</h1>
  </div>

  <div class="admin-settings-tabs">
    <nav>
      <ul>
        <li [class.active]="activeTab() === 'overview'" [tabindex]="activeTab() === 'overview' ? 0 : -1" (click)="setActiveTab('overview')" (keydown)="onKeyDown($event, 'overview')">
          <a>OVERVIEW</a>
        </li>
        <li [class.active]="activeTab() === 'branding'" [tabindex]="activeTab() === 'branding' ? 0 : -1" (click)="setActiveTab('branding')" (keydown)="onKeyDown($event, 'branding')">
          <a>BRANDING</a>
        </li>
        <li [class.active]="activeTab() === 'emails'" [tabindex]="activeTab() === 'emails' ? 0 : -1" (click)="setActiveTab('emails')" (keydown)="onKeyDown($event, 'emails')">
          <a>EMAILS</a>
        </li>
        <li [class.active]="activeTab() === 'integrations'" [tabindex]="activeTab() === 'integrations' ? 0 : -1" (click)="setActiveTab('integrations')" (keydown)="onKeyDown($event, 'integrations')">
          <a>INTEGRATIONS</a>
        </li>
        <li [class.active]="activeTab() === 'sites'" [tabindex]="activeTab() === 'sites' ? 0 : -1" (click)="setActiveTab('sites')" (keydown)="onKeyDown($event, 'sites')">
          <a>SITES & USERS</a>
        </li>
      </ul>
    </nav>
  </div>

  <div class="admin-settings-content">
    <!-- Overview Tab Content - Terms and Conditions Editor -->
    @if(activeTab() === 'overview') {
    <div class="tab-content">
      <app-terms-editor></app-terms-editor>
      
      <!-- Accessibility Editor -->
      <div class="editor-spacing">
        <app-accessibility-editor></app-accessibility-editor>
      </div>
    </div>
    }

    @if(activeTab() === 'sites') {
    <!-- Site Management Tab Content -->
    <div class="tab-content">
      <h2>Sites & Users</h2>
      <div class="card">
        <app-sites-table></app-sites-table>
      </div>
    </div>
    }
    @if(activeTab() === 'branding') {
    <!-- Branding Configuration Tab Content -->
    <div class="tab-content">
      <app-branding-editor></app-branding-editor>
    </div>
    }

    @if(activeTab() === 'emails') {
    <div class="tab-content">
      <app-email-editor></app-email-editor>
    </div>
    }

    @if(activeTab() === 'integrations') {
    <div class="tab-content">
      <app-integration-editor></app-integration-editor>
    </div>
    }
  </div>
</div>